import React from "react";
import { NavLink } from "react-router";
import styles from "./navigation-item.module.css";

const NavItem = ({ to, src, alt, text, srcActive } = {}) => {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `${styles["nav-item"]} ${isActive ? styles.active : ""}`
      }
      data-testid={`${text}-nav-item`}
      title={text}
    >
      {({ isActive }) => (
        <>
          <div data-testid={`${text}-icon`}>{isActive ? srcActive : src}</div>
          <p className={styles.text}>{text}</p>
        </>
      )}
    </NavLink>
  );
};

export default NavItem;
